<template>
  <div class="not-found">
    <div class="el-message-box__wrapper" style="z-index: 2006;">
      <div class="el-message-box el-message-box--center">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <div class="el-message-box__status el-icon-warning"></div>
            <span>提示</span>
          </div>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__message">
              <p>页面不存在，<span style="color: #f56c6c">{{ time }}</span>秒后自动返回</p>
            </div>
          </div>
        </div>
        <div class="el-message-box__btns">
          <button type="button" class="el-button el-button--default el-button--small el-button--primary">
            <span @click="goBack">立即返回</span>
          </button>
        </div>
      </div>
    </div>
    <div class="v-modal" style="z-index: 2004;"></div>
  </div>
</template>
<script>
export default {
  name: 'notFound',
  data () {
    return {
      time: 5,
      timer: null
    }
  },
  methods: {
    goBack () {
      this.$router.replace('/index').catch(() => {})
    }
  },
  created () {
    this.timer = setInterval(() => {
      this.time--;
      if (this.time <= 0) {
        clearInterval(this.timer);
        this.$router.replace('/index').catch(() => {})
      }
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style scoped>

</style>
